module.exports = __webpack_public_path__ + "img/schneider_evlink.94865804.jpg";